/** Whole seconds left on a bar of `tfSec` once `progress` (0..1) of it has played. */
export function secondsLeft(tfSec: number, progress: number): number {
  const p = Number.isFinite(progress) ? Math.min(1, Math.max(0, progress)) : 0
  return Math.max(0, Math.floor(tfSec * (1 - p)))
}

const pad = (n: number) => String(n).padStart(2, '0')

/** Time left on the forming bar, as TradingView prints it: mm:ss, hh:mm:ss, or "3d 04h". */
export function formatCountdown(sec: number): string {
  const s = Math.max(0, Math.floor(sec))
  const days = Math.floor(s / 86400)
  const hours = Math.floor((s % 86400) / 3600)
  const minutes = Math.floor((s % 3600) / 60)
  if (days > 0) return `${days}d ${pad(hours)}h`
  if (hours > 0) return `${pad(hours)}:${pad(minutes)}:${pad(s % 60)}`
  return `${pad(minutes)}:${pad(s % 60)}`
}
